





























































































































































































































import {
  Color,
  Flg,
  KainaiKaigaiKb,
  OutStatus,
  SumiFlg,
  KaigaiKobetsuKb,
} from '@/constants/constants';
import { dateStrToNum, downloadFile, getDefaultPagerInfo } from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import '../../../src/assets/scss/activeReportsJS/ar-js-ui.css';
import '../../../src/assets/scss/activeReportsJS/ar-js-viewer.css';
// viewer関連
import { Viewer } from '@grapecity/activereports-vue';
// PDF出力用
import {
  Rdl as ARJS,
  PageReport,
  FontDescriptor,
  FontStore,
} from '@grapecity/activereports/core';
import { PdfExport } from '@grapecity/activereports';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';

const TYPES = {
  SHUKKO: '出庫',
  HAISO: '配送',
};

export default Vue.extend<any, any, any, any>({
  name: 'G_060_ShukkaJunbi_Table',
  components: {
    CtrlMessageDialog,
    Viewer,
    CtrlNormalBtn,
  },
  props: {
    shukkaHassoSumiFlg: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    Color,
    SumiFlg,
    Flg,
    KaigaiKobetsuKb,
    TYPES,
    headers: [
      {
        text: 'ｵｰﾀﾞｰ№',
        value: 'orderNo',
        sortable: true,
        width: 95,
      },
      {
        text: '納品予定日',
        value: 'nohinYoteiYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '出荷予定日',
        value: 'shukkaYoteiYmd',
        sortable: true,
        width: 115,
      },
      {
        text: '出荷倉庫',
        value: 'shukkaSokoMei',
        sortable: true,
        width: 256,
      },
      {
        text: '集荷先倉庫',
        value: 'shukasakiSokoMei',
        sortable: true,
        width: 256,
      },
      {
        text: '配送会社',
        value: 'haisoKaishaMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 340,
      },
      {
        text: '入力事業所',
        value: 'entryJigyoshoMei',
        sortable: true,
        width: 140,
      },
      {
        text: '得意先',
        value: 'tokuisakiMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 340,
      },
      {
        text: '納品先',
        value: 'nohinsakiMei',
        sortable: true,
        width: 408,
      },
      {
        text: '入庫事業所',
        value: 'nyukoJigyoshoMei',
        sortable: true,
        width: 140,
      },
      {
        text: '入庫倉庫',
        value: 'nyukoSokoMei',
        sortable: true,
        width: 256,
      },
      {
        text: '品目（1件目）',
        value: 'himmokuMei',
        class: 'text-truncate',
        cellClass: 'text-truncate',
        sortable: true,
        width: 400,
      },
      {
        text: 'c/s数量計',
        value: 'suryoSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: 'バラ数量計',
        value: 'hasuSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: '重量計',
        value: 'juryoSum',
        sortable: true,
        width: 115,
        class: 'text-end',
        cellClass: 'text-end',
      },
      {
        text: 'データ区分',
        value: 'dataKbMei',
        sortable: true,
        width: 140,
      },
      { text: '', value: 'action', sortable: false, width: 130 },
    ],
    footerProps: {},
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    isClearTable: false,
    isReload: false,

    // viewer関連
    reportUrl: '',
    reportArray: [] as ARJS.Report[], // レポートデータ配列
    exportDialogShow: false,
    shukkoIraiReportData: '',
    reportDataSet: '',
    reportData: '',
    reportParameter: [],
    actionType: '',
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
    tableHeight() {
      return this.$vuetify.breakpoint.height - 420;
    },
    itemsDisp() {
      return this.shukkaHassoSumiFlg
        ? this.items
        : this.items.filter((item: any) => item.shukkaHassoSumiFlg === SumiFlg.MI);
    },
    showSelect() {
      return this.itemsDisp.some(
        (item: any) => item.kakuteiSumiFlg === SumiFlg.MI
      );
    },
    localState: {
      get() {
        return this.selected;
      },
      set(value: any) {
        this.$emit('update:selected', value);
      },
    },
  },
  methods: {
    customSearch(_value: any, search: string | null, item: any) {
      const filterValues = [
        item['orderNo'],
        item['nohinYoteiYmd'],
        item['shukkaYoteiYmd'],
        item['shukkaSokoMei'],
        item['shukasakiSokoMei'],
        item['haisoKaishaMei'],
        item['entryJigyoshoMei'],
        item['tokuisakiMei'],
        item['nohinsakiMei'],
        item['nyukoJigyoshoMei'],
        item['nyukoSokoMei'],
        item['himmokuMei'],
        item['dataKbMei'],
      ];

      return filterValues.some(
        (v: any) =>
          v &&
          v
            .toString()
            .toLowerCase()
            .includes(search ? search.toLowerCase() : '')
      );
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isClearTable) {
        this.isClearTable = false;
        this.$emit('clear-table');
      }
      if (this.isReload) {
        this.isReload = false;
        this.$emit('reload');
      }
    },
    async handlePreview(item: any, actionType: string) {
      const actionName =
        actionType === TYPES.SHUKKO
          ? 'g060/putShukkoIraisho'
          : actionType === TYPES.HAISO
          ? 'g060/putHaisoIraisho'
          : '';
      this.$store.dispatch('common/setIsLoading', true);
      const requestData = {
        commonInfo: {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        },
        shoriCntrol: {
          kainaiKaigaiKb: KainaiKaigaiKb.KAIGAI,
          kakuteiFlg: Flg.FLG_FALSE,
        },
        kakuteiInfo: {
          orderNo: item.orderNo,
          shukkaYoteiYmd: dateStrToNum(item.shukkaYoteiYmd),
          nohinYoteiYmd: dateStrToNum(item.nohinYoteiYmd),
          shukkaSokoCd: +item.shukkaSokoCd,
          haisoKb: +item.haisoKb,
          haisoTehaiKb: +item.haisoTehaiKb,
          tokuisakiCd: +item.tokuisakiCd,
          nohinsakiCd: +item.nohinsakiCd,
          nyukoSokoCd: +item.nyukoSokoCd,
          haisoKaishaCd: +item.haisoKaishaCd,
          shukkoIraiMakeFlg: +item.shukkoIraiMakeFlg,
          haisoIraiMakeFlg: +item.haisoIraiMakeFlg,
          juchuEntryJigyoshoCd: +item.juchuEntryJigyoshoCd,
          juchuEntryYmd: dateStrToNum(item.juchuEntryYmd),
          juchuNo: +item.juchuNo,
          hatchuIraiJigyoshoCd: +item.hatchuIraiJigyoshoCd,
          hatchuIraiEntryYmd: dateStrToNum(item.hatchuIraiEntryYmd),
          hatchuIraiNo: +item.hatchuIraiNo,
          idoIraiJigyoshoCd: +item.idoIraiJigyoshoCd,
          idoIraiEntryYmd: dateStrToNum(item.idoIraiEntryYmd),
          idoIraiNo: +item.idoIraiNo,
          hatchuJigyoshoCd: +item.hatchuJigyoshoCd,
          hatchuEntryYmd: dateStrToNum(item.hatchuEntryYmd),
          hatchuNo: +item.hatchuNo,
          koshinCountHeader: +item.koshinCountHeader,
          koshinCountDetailSum: +item.koshinCountDetailSum,
        },
      };
      const data = await this.$store.dispatch(actionName, requestData);

      this.$store.dispatch('common/setIsLoading', false);
      if (
        data &&
        data.status == 200 &&
        data.data &&
        data.data.error &&
        data.data.error.outStatus &&
        data.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = data.data.error.messageID;
        this.messageTextParam = data.data.error.messageArgs;
        this.messageShow = true;
        this.isClearTable = true;
        return;
      }
      this.actionType = actionType;
      const reportName =
        actionType === TYPES.SHUKKO
          ? 'N_Shu032_ShukkoIraisho'
          : actionType === TYPES.HAISO
          ? 'N_Shu031_HaisoIraisho'
          : '';

      const reportResponse = await fetch(`/reports/${reportName}.rdlx-json`);
      this.exportDialogShow = true;
      const report = await reportResponse.json();
      report.DataSources[0].ConnectionProperties.ConnectString =
        'jsondata=' +
        JSON.stringify(
          actionType === TYPES.SHUKKO
            ? data.data.responseData.shukkoIraiReportData
            : data.data.responseData.haisoIraiReportData
        );
      this.reportData = report;
      this.reportDataSet = await data;
      this.reportParameter = [
        { Name: 'dataString', Value: [JSON.stringify(data)] },
      ];
      if (this.$refs.reportViewer) {
        this.$refs.reportViewer
          .Viewer()
          .open(report, { ReportParams: this.reportParameter });
        // 帳票フォント定義
        const fonts: FontDescriptor[] = [
          {
            name: 'ＭＳ ゴシック',
            source: '/fonts/msgothic.ttc',
            postscriptName: 'MS-Gothic',
          },
          { name: 'IPAゴシック', source: '/fonts/ipag.ttf' },
        ];
        FontStore.registerFonts(...fonts);
      }
    },
    async exportOrder() {
      const title =
        this.actionType === TYPES.SHUKKO
          ? 'N_Shu032_ShukkoIraisho'
          : this.actionType === TYPES.HAISO
          ? 'N_Shu031_HaisoIraisho'
          : '';
      const fileName =
        this.actionType === TYPES.SHUKKO
          ? 'N_Shu032_ShukkoIraisho_PDF'
          : this.actionType === TYPES.HAISO
          ? 'N_Shu031_HaisoIraisho_PDF'
          : '';

      if (!title && !fileName) {
        console.log('不明なデータ');
        return;
      }

      const newReport = new PageReport({ language: 'jp' });
      const data = await this.reportDataSet;
      const doc = await newReport.load(this.reportData).then(() => {
        newReport.parameters['dataString'].values = [JSON.stringify(data)];
        return newReport.run();
      });
      PdfExport.exportDocument(doc, {
        info: {
          title,
        },
      })
        .then((result) => {
          result.download(fileName);
        })
        .catch(console.error);
    },
    async handleDownloadFile(s3Url: any) {
      let dataUri = '';
      const response = await this.$store.dispatch('common/gDownloadFile', {
        s3Url,
      });
      if (
        response &&
        response.status == 200 &&
        response.data &&
        response.data.error &&
        response.data.error.outStatus &&
        response.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (response.data.error.messageID == 'KI_W107') {
          this.isReload = true;
          this.messageId = 'KI_W124';
        } else {
          this.messageId = response.data.error.messageID;
        }
        this.messageTextParam = response.data.error.messageArgs;
        this.messageShow = true;
        return;
      } else {
        dataUri = response.data.responseData.dataUri;
        const fileName = decodeURI(s3Url).split('/');
        downloadFile(dataUri, fileName[fileName.length - 1]);
      }
    },
  },
  mounted() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
